import { appStorage } from './betaStorage'
export interface YouthNote {
  id: string
  participantId: string
  title: string
  body: string
  createdAt: string
  updatedAt: string
}

const NOTES_KEY = 'schub.youthNotes.v1'

export function loadYouthNotes(participantId: string): YouthNote[] {
  try {
    const parsed = JSON.parse(appStorage.getItem(NOTES_KEY) || '[]')
    if (!Array.isArray(parsed)) return []
    return parsed
      .filter((note) => note?.participantId === participantId)
      .sort((a, b) => String(b.updatedAt).localeCompare(String(a.updatedAt)))
  } catch {
    return []
  }
}

function loadAllNotes(): YouthNote[] {
  try {
    const parsed = JSON.parse(appStorage.getItem(NOTES_KEY) || '[]')
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

export function saveYouthNote(participantId: string, title: string, body: string) {
  const now = new Date().toISOString()
  const note: YouthNote = {
    id: `youth-note-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    participantId,
    title: title.trim(),
    body: body.trim(),
    createdAt: now,
    updatedAt: now,
  }
  appStorage.setItem(NOTES_KEY, JSON.stringify([note, ...loadAllNotes()]))
  window.dispatchEvent(new Event('schub:youth-notes'))
  return note
}

export function deleteYouthNote(noteId: string) {
  appStorage.setItem(NOTES_KEY, JSON.stringify(loadAllNotes().filter((note) => note.id !== noteId)))
  window.dispatchEvent(new Event('schub:youth-notes'))
}

